import { render } from "./Invoices.vue?vue&type=template&id=507a9856"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"
script.render = render

export default script